export default __webpack_public_path__ + "static/media/allgemein_23.48afb4b7.jpg";